import moment from 'moment/moment'

import { AudioCircleType, QuickGuiddeType, Shape, TextShapeType } from 'app/types'
import { isValidUrl } from 'modules'
import { firebaseConfig } from 'env'

const FALLBACK_IMAGE = `https://storage.googleapis.com/${firebaseConfig.projectId}.appspot.com/public/images/defaultAudio.png`

// this function also is using in the `PdfDocument`. If you want to change something here -
// please check impact in the `PdfDocument` file
export const getStepData = (step: QuickGuiddeType) => {
    const { type, layers, url } = step

    const hasBgImage = layers.find(layer => layer.type === Shape.Image && layer.isBackground)
    const hasAudioShape = layers.find(layer => layer.type === Shape.AudioCircle) as AudioCircleType

    const getStepTitle = () => {
        const defaultTitle = getStepText(step)

        if (type !== 'urlChange') return defaultTitle

        const parsedTitle = getStepText(step).split('"')
        const hasValidLink = parsedTitle.length >= 3 ? isValidUrl(parsedTitle[1]) : false

        if (!hasValidLink) return defaultTitle
        return parsedTitle.filter(e => e !== parsedTitle[1]).join('')
    }

    const getStepGoTo = () => {
        const defaultUrl = { href: '#', host: '' }

        try {
            return url ? new URL(url.includes('http') ? url : `https://${url}`) : defaultUrl
        } catch {
            return defaultUrl
        }
    }

    const getStepUrlChange = () => {
        if (type !== 'urlChange') return ''

        const parsedTitle = getStepText(step).split('"')

        return parsedTitle.length >= 3 ? (isValidUrl(parsedTitle[1]) ? parsedTitle[1] : '') : ''
    }

    const getStepAvatar = () => {
        if (hasAudioShape?.render?.type === 'svgRender') {
            return FALLBACK_IMAGE
        }

        return hasAudioShape?.render?.url || FALLBACK_IMAGE
    }

    return {
        stepAvatar: getStepAvatar(),
        stepTitle: getStepTitle(),
        stepGoTo: getStepGoTo(),
        stepUrlChange: getStepUrlChange(),
        hasBgImage
    }
}

export const getStepText = (step: QuickGuiddeType) => {
    // step has a title, use it
    if (step.title) return step.title.replace('"Go here"', 'Go here')

    // step does not hava e a title, look for text in the layers
    // filter only text layers that has a title
    const filteredLayers = step.layers.filter(layer => layer.type === 'text' && layer.title !== '')
    // use the first title if found as the step title
    if (filteredLayers.length) {
        return (filteredLayers[0] as TextShapeType).title
    }
    return ''
}

export const getVideoDuration = (duration: number) => {
    const videoDuration = moment.duration(duration, 'seconds')
    const seconds = parseInt(videoDuration.asSeconds().toString())
    const minutes = parseInt(videoDuration.asMinutes().toString())
    return `${
        seconds >= 60
            ? `${minutes} minute${minutes < 2 ? '' : 's'} read`
            : `${seconds} second${seconds > 1 ? 's' : ''} read`
    }`
}
